import { mutatePositions } from '../../mutations/mutatePositions';
import { organizationAPI } from 'api/phases/endpoints';

export const removePosition = async (positionId: number) => {
  await organizationAPI.deletePosition(positionId);
  await mutatePositions();
};
